var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 27 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icUserHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top-header-skeleton",
    transform: "translate(-1362.000000, -29.000000)",
    fill: "#666666",
    fillRule: "nonzero",
    stroke: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Date-Finder-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-top-header",
    transform: "translate(1184.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(168.200000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(22.500000, 25.000000) scale(-1, 1) translate(-22.500000, -25.000000) translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,15.7258065 C8.27556452,15.7258065 4.83870968,12.2889516 4.83870968,8.06451613 C4.83870968,3.84008065 8.27556452,0.403225806 12.5,0.403225806 C16.7244355,0.403225806 20.1612903,3.84008065 20.1612903,8.06451613 C20.1612903,12.2889516 16.7244355,15.7258065 12.5,15.7258065 Z M12.5,3.46774194 C9.96533871,3.46774194 7.90322581,5.52985484 7.90322581,8.06451613 C7.90322581,10.5991774 9.96533871,12.6612903 12.5,12.6612903 C15.0346613,12.6612903 17.0967742,10.5991774 17.0967742,8.06451613 C17.0967742,5.52985484 15.0346613,3.46774194 12.5,3.46774194 Z M12.5,16.1451613 C19.3925253,16.1451613 25,21.6304156 25,28.3727114 L25,29.8548387 L0,29.8548387 L0,28.3727114 C0,21.6304156 5.60747475,16.1451613 12.5,16.1451613 Z M3.15141414,26.8905841 L21.8485859,26.8905841 C21.1212121,22.4849114 17.2059596,19.1094159 12.5,19.1094159 C7.7940404,19.1094159 3.87888889,22.4849114 3.15141414,26.8905841 Z",
    id: "icUserHeader"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserHeader);
export default __webpack_public_path__ + "static/media/icUserHeader.26dc290651b3af01107efdf67743e404.svg";
export { ForwardRef as ReactComponent };